import { getQueryString, isTHSApp, isTHSI18NApp } from '@fs/utils'
import { ERROR_COCES, ERROR_CODE_MAP, THS_I18N_TICKET_KEY } from '../contansts'
import { Toast } from 'vant'
import { closePage } from '@/utils'

export default response => {
    if ((isTHSI18NApp() || isTHSApp()) && (getQueryString('ticket') || localStorage.getItem(THS_I18N_TICKET_KEY))) {
        // 添加判断是为了扫码调试无ticket能正常展示页面
        const logoutCodes = [
            ERROR_CODE_MAP.IASIA_UNVALID_SESSION,
            ERROR_CODE_MAP.ERROR_SESSION,
            ERROR_CODE_MAP.ERROR_SESSION_EXPIRE,
            ERROR_CODE_MAP.ERROR_UIN,
            ERROR_CODE_MAP.ERROR_TRADE_SESSION_EXPIRE,
            ERROR_COCES.MYLINK_REJECT,
        ]
        if (logoutCodes.includes(response?.data?.error?.code)) {
            Toast('提示登录失效，请重新登录')
            localStorage.clear()
            closePage()
            return Promise.reject(response)
        }
    }
    return response
}
